import React from 'react'
import {
  CONTENT_TYPE,
  IImageWithModalVideo as IContentfulImageWithModalVideo,
} from 'marketing-site/@types/generated/contentful'
import {
  ImageWithModalVideo,
  IProps as IImage,
} from 'marketing-site/src/mvp/library/elements/ImageWithModalVideo'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { renderTransformedComponent } from 'marketing-site/lib/transformedComponents'

export const ContentfulImageWithModalVideo = (
  image: IContentfulImageWithModalVideo,
): React.ReactElement => {
  return (
    <EntryMarker entry={image}>
      {() => <ImageWithModalVideo {...transformImageWithModalVideo(image)} />}
    </EntryMarker>
  )
}

const transformElement = (
  element:
    | IContentfulImageWithModalVideo['fields']['image']
    | IContentfulImageWithModalVideo['fields']['modalVideo'],
) => {
  if (!element) return
  const contentTypeId = element?.sys.contentType?.sys.id as CONTENT_TYPE
  return renderTransformedComponent(contentTypeId, element)
}

export function transformImageWithModalVideo({ fields }: IContentfulImageWithModalVideo): IImage {
  return {
    image: transformElement(fields.image),
    modalVideo: transformElement(fields.modalVideo),
  }
}
